import { registerLocaleData } from '@angular/common';
import localeUs from '@angular/common/locales/en';
import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewChild,
  ViewContainerRef,
  ViewEncapsulation,
  ViewRef,
} from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MultiCartService } from '@spartacus/cart/base/core';
import { ActiveCartFacade, Cart } from '@spartacus/cart/base/root';
import {
  AuthService,
  BaseSiteService,
  GlobalMessageService,
  GlobalMessageType,
  Product,
  ProductService,
  RoutingService,
  TranslationService,
  UserIdService,
  WindowRef,
} from '@spartacus/core';
import { DeviceDetectorService } from 'ngx-device-detector';
import { Observable, Subject, Subscription, combineLatest, iif, of } from 'rxjs';
import { debounceTime, filter, map, pairwise, switchMap, take, tap } from 'rxjs/operators';
import { CUSTOM_LAUNCH_CALLER } from 'src/app/dialog/custom-launch-dialog-config';
import { CheckoutConstants } from 'src/app/model/checkout.model';
import { DealerPrice } from 'src/app/model/dealer-price.model';
import { BaseSiteConfigService } from 'src/app/service/base-site/base-site-config.service';
import { CartExtendService } from 'src/app/service/cart/cart-extend.service';
import { CheckoutServiceExtends } from 'src/app/service/checkout/checkout.service';
import { ComponentService } from 'src/app/service/component.service';
import { ShimanoCountryService } from 'src/app/service/country/shimano-country.service';
import { DealerPriceService } from 'src/app/service/dealer-price/dealer-price.service';
import { ShimanoLanguageService } from 'src/app/service/language/shimano-language.service';
import { StandardModalService } from 'src/app/service/modal/standard-modal.service';
import { CustomProductService } from 'src/app/service/product/custom-product.service';
import { StorageService } from 'src/app/service/storage/storage.service';
import { QUICK_ORDER, TooltipIconService } from 'src/app/service/tooltip-icon/tooltip-icon.service';
import { CurrentBusinessType } from 'src/app/utility/current-businesstype';
import { DealerPriceCheckerService } from 'src/app/utility/dealer-price-checker.service';
import { ShimanoUtilMethod } from 'src/app/utility/methods.util';
import { OrderHistoryService } from '../../../../service/orders/order-history.service';
@Component({
  selector: 'app-quick-order',
  templateUrl: './quick-order.component.html',
  styleUrls: ['./quick-order.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class QuickOrderComponent implements OnInit, OnDestroy {
  private subject: Subject<string> = new Subject();
  userCurrent$: Observable<string> = this.userIdService.getUserId();
  searchText: string;
  errorText: string;
  form: FormGroup;
  entries: any[] = [];
  private sessionStorage: Storage;
  showSrp = false;
  srpSubscription$: Subscription;
  dealerPrices: DealerPrice[];
  productCodesList: string[] = [];
  cartDisable: boolean;
  baseSite$: Observable<string> = this.baseService.getActive();
  skipVariantCategory: string;
  default = 'default';
  min = 1;
  max = 999;
  step = 1;
  cartId: any;
  errorSKUExistForm: string;
  hasDealerPrice = true;
  dealerPriceCheckerSubscription$: Subscription;
  languageSubscription$: Subscription;
  activeCartIdSubscription$: Subscription;
  @ViewChild('skuItemNumber', { static: false }) private skuItemNumber: ElementRef<HTMLInputElement>;
  translationSubscription$: Subscription;
  formValueChangeSubscription$: Subscription;
  searchTextValue: any;
  lastSearchText: string;
  enableSearch = true;
  hasDealerPriceOf: any = {};
  backOrderModalSubscription: Subscription;
  isBackOrderPopupEnabled: boolean = false;
  addToCartInprogress = false;
  manualAllocationEnabled: boolean = false;

  activeCountry$: Observable<string> = this.countryService.getActive();

  tooltipIconConfig$: Observable<any> = this.activeCountry$.pipe(
    take(1),
    switchMap((activeCountry) => this.tooltipIconService.getTooltipIconConfig(activeCountry, QUICK_ORDER))
  );

  showGstExclusive$: Observable<boolean> = this.activeCountry$.pipe(
    take(1),
    switchMap((activeCountry) =>
      this.checkoutServiceExtends.isCheckoutFeatureEnabled$(activeCountry, CheckoutConstants.GST_EXCLUSIVE)
    )
  );
  businessType: string;

  productCategories: any = {};
  gtmbusinessType: string = this.currentBusinesstype.getBusinessType();
  affiliation = `/${this.gtmbusinessType}/${this.gtmActiveCountry}/${this.activeLanguage}`;
  // getProductDetails: any;
  product$: Observable<Product>;
  private bodyArray: any = [];

  constructor(
    protected productService: CustomProductService,
    private cd: ChangeDetectorRef,
    private componentService: ComponentService,
    private dealerPriceService: DealerPriceService,
    private cdr: ChangeDetectorRef,
    private cartService: CartExtendService,
    private multiCartService: MultiCartService,
    private authService: AuthService,
    private baseService: BaseSiteService,
    private translation: TranslationService,
    private dealerPriceChecker: DealerPriceCheckerService,
    private languageService: ShimanoLanguageService,
    private countryService: ShimanoCountryService,
    private tooltipIconService: TooltipIconService,
    private checkoutServiceExtends: CheckoutServiceExtends,
    private userIdService: UserIdService,
    private currentBusinesstype: CurrentBusinessType,
    public deviceDetectorService: DeviceDetectorService,
    private gtmProductService: ProductService,
    private orderHistoryService: OrderHistoryService,
    private baseSiteConfigService: BaseSiteConfigService,
    winRef: WindowRef,
    private messageService: GlobalMessageService,
    private routingService: RoutingService,
    private activeCartService: ActiveCartFacade,
    protected modalService: StandardModalService,
    protected el: ElementRef,
    protected vcr: ViewContainerRef,
    private storageService: StorageService,
    private customProductService: CustomProductService
  ) {
    this.form = this.createFormGroup();
    this.sessionStorage = winRef.sessionStorage;
    registerLocaleData(localeUs, 'Us');

    this.productService
      .getSkipVariant()
      .pipe(take(1))
      .subscribe((resp) => {
        this.skipVariantCategory = resp[this.baseSiteId]
          ? resp[this.baseSiteId].defaultVariantCategory
          : resp[this.default].defaultVariantCategory;
      });
  }
  get baseSiteId(): string {
    let baseSiteId: string;
    this.baseSite$.pipe(take(1)).subscribe((baseSiteData) => (baseSiteId = baseSiteData));
    return baseSiteId;
  }

  createFormGroup() {
    return new FormGroup({
      queryProduct: new FormControl(''),
    });
  }

  get queryProduct() {
    return this.form.get('queryProduct');
  }

  get getCurrency() {
    return this.sessionStorage.currency;
  }

  get activeCurrency$(): Observable<string> {
    return this.componentService.activeCurrency$;
  }

  get userCurrent(): string {
    let userCurrent: string;
    this.userCurrent$.pipe(take(1)).subscribe((userId) => (userCurrent = userId));
    return userCurrent;
  }

  get gtmActiveCountry(): string {
    let activeCountry: string;
    this.countryService.getActive().subscribe((country) => (activeCountry = country));
    return activeCountry;
  }

  get activeLanguage(): string {
    let activeLanguage: string;
    this.languageService.getActive().subscribe((lang) => (activeLanguage = lang));
    return activeLanguage;
  }

  ngOnInit() {
    this.isBackOrderModalEnabled();
    this.getActiveCartId(); // get the current cartID

    this.subject.pipe(debounceTime(500)).subscribe((searchTextValue) => {
      if (this.enableSearch) this.handleSearch(searchTextValue);
    });

    this.customProductService
      .isProductManualAllocationEnabled$()
      .pipe(take(1))
      .subscribe((isEnabled) => (this.manualAllocationEnabled = isEnabled));

    this.getInitSrpToggleValue();

    this.srpSubscription$ = this.componentService.srpToggle$.subscribe((checked) => {
      this.showSrp = checked;
      this.cdr.detectChanges();
    });

    this.dealerPriceCheckerSubscription$ = this.componentService.hasDealerPrice$.subscribe((hasDealerPrice) => {
      this.hasDealerPriceOf[this.searchText] = hasDealerPrice;
      if (!(this.cdr as ViewRef).destroyed) {
        this.cdr.detectChanges();
      }
    });

    // update entries onChange of language
    this.languageSubscription$ = this.languageService
      .getActive()
      .pipe(
        pairwise(),
        tap(([prevLanguage, currentLanguage]) => {
          if (prevLanguage !== currentLanguage && this.errorText) {
            this.enableSearch = true;
            this.onKeyUp(this.searchTextValue);
          }
        }),
        switchMap(([prevLanguage, currentLanguage]) =>
          iif(
            () => prevLanguage !== currentLanguage,
            combineLatest(
              this.entries.map((entry) =>
                this.productService.getProductInfo(entry.code).pipe(map((d) => ({ ...d.product })))
              )
            ),
            of(null)
          )
        ),
        filter(Boolean)
      )
      .subscribe((entries: any) => {
        entries.forEach((entry: any, index: number) => {
          if (entry.name !== undefined) this.entries[index].name = entry.name;
          if (entry.superCategories !== undefined) this.entries[index].superCategories = entry.superCategories;
        });
        this.cdr.detectChanges();
      });

    this.translationSubscription$ = this.translation
      .translate(`cart.quickOrder.queryProduct.errorSKUExistForm`)
      .subscribe((translate) => (this.errorSKUExistForm = translate));

    this.formValueChangeSubscription$ = this.form.valueChanges.subscribe((data) => {
      if (!data.queryProduct) this.lastSearchText = '';
      this.enableSearch = data.queryProduct !== this.lastSearchText;
    });
    this.businessType = this.currentBusinesstype.getBusinessType();
  }

  getActiveCartId() {
    this.activeCartIdSubscription$ = this.activeCartService
      .takeActiveCartId()
      .pipe(
        switchMap((currentCartId) => {
          let cartId = currentCartId;
          if (!cartId) {
            return this.multiCartService.createCart({
              userId: this.userCurrent,
              extraData: {
                active: true,
              },
            });
          } else {
            this.cartId = cartId;
            return of(null);
          }
        }),
        filter(Boolean),
        tap((cartId: Cart) => {
          this.cartId = cartId;
        })
      )
      .subscribe();
  }

  onKeyUp(searchTextValue: string) {
    this.subject.next(searchTextValue);
    this.searchTextValue = searchTextValue;
  }

  isBackOrderModalEnabled = () => {
    this.backOrderModalSubscription = this.getBackOrderModalConfig$().subscribe((backOrder) => {
      this.isBackOrderPopupEnabled = backOrder === 'true';
      this.cd.detectChanges();
    });
  };

  getBackOrderModalConfig$(): Observable<string> {
    return this.baseSiteConfigService
      .getBaseSiteConfigValues$(['shimano.backorder.popup.message'])
      .pipe(
        map(
          (configs) =>
            configs &&
            configs
              .filter((config: any) => config.key === 'shimano.backorder.popup.message')
              .map((res: any) => res.value)[0]
        )
      );
  }

  backorderCartModal(cart: any = null, unfilteredForm: any): void {
    this.addToCartInprogress = false;
    this.cd.detectChanges();

    this.modalService
      .openDialog(CUSTOM_LAUNCH_CALLER.BACKORDER_CART_MODAL, this.el, this.vcr, {
        backorderEntries: cart,
        formEntries: unfilteredForm,
        type: 'quickorder',
      })
      ?.pipe(take(1))
      .subscribe();

    const backorderModalSub$ = this.modalService.getClosedModalData().subscribe((result) => {
      if (result !== undefined) {
        if (result && result !== 0 && result !== 'Cross click') {
          this.componentService.setMiniCartLoading(false);
          this.routingService.goByUrl('/cart');
          this.cd.detectChanges();
        }
        backorderModalSub$.unsubscribe();
      }
    });
  }

  private showGlobalMessage(text: string, messageType: GlobalMessageType, param?: string) {
    this.messageService.add({ key: text, params: { productName: param } }, messageType);
  }

  backOrderCheck(backorderEntries: any) {
    if (!this.addToCartInprogress) {
      this.addToCartInprogress = true;
      if (this.isBackOrderPopupEnabled) {
        this.bodyArray = [];

        backorderEntries.forEach((entry: any) => {
          const jsonBody = {
            quantity: entry['qty'],
            product: {
              code: entry['code'],
            },
          };
          this.bodyArray.push(jsonBody);
        });

        let strPayload = JSON.stringify(this.bodyArray);
        let payloadHead = '{"orderEntries": ';
        let payloadfoot = ' }';
        let unparsedPayload = payloadHead.concat(strPayload, payloadfoot);

        const parsedPayload = JSON.parse(unparsedPayload);
        const entries = this.orderHistoryService.getInventory(parsedPayload);
        entries.subscribe((data) => {
          if (data?.inventoryBackorderList?.length > 0) {
            this.backorderCartModal(data, backorderEntries);
          } else {
            this.addQuickOrder();
          }
        });
      } else {
        this.addQuickOrder();
      }
    }
  }

  addQuickOrder() {
    this.addToCartInprogress = false;
    this.cd.detectChanges();

    const submitEntries = this.entries.map((entry) => {
      const obj = {
        productCode: entry.code,
        quantity: Number(entry.qty),
      };
      return obj;
    });
    const gtmDataLayer = this.entries.map((entry) => {
      const obj = {
        currency: this.storageService.getSessionStorageItem('currency'),
        item_id: entry.code,
        item_name: entry.name,
        affiliation: this.affiliation,
        item_brand: entry?.brand?.name,
        item_categories: entry.categories,
        price: this.dealerPriceValue(entry.code),
        quantity: Number(entry.qty),
      };
      return obj;
    });

    this.modalService
      .openDialog(CUSTOM_LAUNCH_CALLER.SUBMIT_MODAL, this.el, this.vcr, {
        entries: submitEntries,
        activeCartId: this.cartId,
        gtmDataLayer: gtmDataLayer,
      })
      ?.pipe(take(1))
      .subscribe();
  }

  getProductDetails(productCode: string): Observable<Product> {
    return this.gtmProductService.get(productCode);
  }

  deleteEntry(index: any) {
    if (this.lastSearchText === this.entries[index].code) {
      this.skuItemNumber.nativeElement.focus();
      this.skuItemNumber.nativeElement.blur();
      this.enableSearch = true;
    }
    this.entries.splice(index, 1);
    this.cartCheck();
    this.cd.markForCheck();
    this.skuItemNumber.nativeElement.focus();
  }

  clearAll() {
    this.modalService
      .openDialog(CUSTOM_LAUNCH_CALLER.CLEAR_MODAL, this.el, this.vcr, {
        entries: this.entries,
      })
      ?.pipe(take(1))
      .subscribe();

    const resetFormSub$ = this.modalService.getClosedModalData().subscribe((entries) => {
      if (entries !== undefined) {
        if (entries && typeof entries !== 'string') {
          this.entries = entries;
          this.form.get('queryProduct').setValue('');
          this.form.get('queryProduct').setErrors(null);
          this.cd.markForCheck();
        }
        resetFormSub$.unsubscribe();
      }
    });
  }

  handleSearch(event: any) {
    this.lastSearchText = event.target.value;
    if (event.target.value.length > 3) {
      this.searchText = event.target.value;
      this.form.get('queryProduct').disable();
      this.productService
        .getProductInfo(this.searchText)
        .pipe(take(1))
        .subscribe(
          (data) => {
            this.form.get('queryProduct').enable();
            if (Object.keys(data.error).length !== 0) {
              this.form.get('queryProduct').setErrors({ errorProduct: true });
              this.errorText = data.error.message;
            } else {
              this.updateEntries(data.product);
              this.skuItemNumber.nativeElement.focus();
            }
            if (!this.hasDealerPriceOf[this.searchText]) this.hasDealerPriceOf[this.searchText] = true;
          },
          () => {
            this.form.get('queryProduct').enable();
            this.form.get('queryProduct').setErrors({ errorProduct: true });
            this.errorText = 'error fetching the data from the server';
          }
        );
    } else {
      if (event.target.value.length === 0) {
        this.form.get('queryProduct').setErrors(null);
      }
    }
  }
  updateEntries(product: any) {
    if (this.entries.find((entry) => entry.code === product.code)) {
      this.form.get('queryProduct').setErrors({ errorProduct: true });
      this.errorText = this.errorSKUExistForm;
    } else {
      let getCategories: any = [];

      const prod = {
        ...product,
        categories: getCategories,
        qty: product.minOrderQuantity ? product.minOrderQuantity : String(1),
        isMoqError: false,
      };

      this.product$ = this.getProductDetails(product.code);
      this.product$.subscribe((product) => {
        if (product) {
          getCategories.push(product.categories);
        }
      });

      this.entries.push(prod);
      this.form.get('queryProduct').setValue('');
      this.form.get('queryProduct').setErrors(null);
      this.productCodesList.push(product.code);
      const uniqueValue = new Set(this.productCodesList);
      const backToProdCodesArray = [...uniqueValue];
      this.getDealerPrices(backToProdCodesArray);
      this.cd.markForCheck();
      this.cartCheck();
    }
  }
  cartCheck() {
    this.cartDisable = false;
    this.entries.forEach((value) => {
      this.cartDisable = this.cartDisable || value.qty < 1;
      this.onInput(value.qty);
    });
  }

  updateCount(index: number, value: number, entry: any): void {
    const val = this.getValidCount(value);
    const minOrderQuantity = entry.minOrderQuantity ? entry.minOrderQuantity : 1;
    const newValue = ShimanoUtilMethod.setMinimumOrderQuantity(val, minOrderQuantity);
    const checkQty = ShimanoUtilMethod.checkUserQuantity(val, minOrderQuantity);
    this.entries[index] = {
      ...entry,
      qty: newValue,
      isMoqError: checkQty > 0 ? true : false,
    };
    this.cd.markForCheck();
    this.cartCheck();
  }

  getValidCount(value: number) {
    if (value < this.min && !(value === 0)) {
      value = this.min;
    }
    if (this.max && value > this.max) {
      value = this.max;
    }
    return value;
  }

  getInitSrpToggleValue() {
    this.showSrp = this.storageService.getLocalStorageItem('showSrp') === 'true';
  }

  getDealerPrices(productCodes: string[]) {
    this.dealerPriceService
      .getDealerPricesByProductCodes(productCodes)
      .pipe(take(1))
      .subscribe((data) => {
        if (data.dealerPrices.length > 0) {
          this.dealerPrices = data.dealerPrices;
          this.cdr.detectChanges();
        } else {
          this.hasDealerPriceOf = {};
        }
      });
  }

  dealerPrice(productCode: string): string {
    if (this.dealerPrices) {
      return this.dealerPriceService.getDealerPriceByProductCode(this.dealerPrices, productCode);
    }
  }

  dealerPriceValue(productCode: string): number {
    if (this.dealerPrices) {
      return this.dealerPriceService.getDealerPriceValueByProductCode(this.dealerPrices, productCode);
    }
  }

  getImageRendition(image: any) {
    let size: string;
    size = ShimanoUtilMethod.imageRendition(80);
    return ShimanoUtilMethod.newImageFormat(image, size);
  }

  numberOnly(event: any): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  checkVariant(variants: any) {
    return variants
      .filter((variant: any) => {
        if (variant.code !== this.skipVariantCategory) {
          return variant;
        }
      })
      .slice(0, 3);
  }

  onInput(value: number) {
    this.cartDisable = !value;
  }

  hasAtLeastOneDealerPrice(entries: any[]): boolean {
    if (!entries.length) {
      return false;
    }
    const codes = entries.map((entry) => entry.code);
    let index = 0;
    for (const code of codes) {
      if (this.dealerPriceValue(codes[index])) return true;
      index++;
    }
    return false;
  }

  ngOnDestroy() {
    if (this.srpSubscription$) {
      this.srpSubscription$.unsubscribe();
    }

    if (this.dealerPriceCheckerSubscription$) {
      this.dealerPriceCheckerSubscription$.unsubscribe();
    }

    if (this.languageSubscription$) {
      this.languageSubscription$.unsubscribe();
    }
    if (this.activeCartIdSubscription$) {
      this.activeCartIdSubscription$.unsubscribe();
    }
    if (this.translationSubscription$) {
      this.translationSubscription$.unsubscribe();
    }
    if (this.formValueChangeSubscription$) {
      this.formValueChangeSubscription$.unsubscribe();
    }
    if (this.backOrderModalSubscription) {
      this.backOrderModalSubscription.unsubscribe();
    }
  }
}
